<div class="container">
  <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
  <div class="mt-3">
    <h2>Dados cadastrais</h2>
    <form [formGroup]="form">
      <div class="bordered-form">
        <div>
            <h4>Revise seus dados cadastrais</h4>
            <p>Você pode editar suas informações nos campos abaixo</p>
        </div>
        <div class="row">
          <div class="col-12 col-md-8">
            <vivest-input
              formControlName="nome"
              label="Nome do Cliente"
              placeholder=""
              name="nome"
              type="text"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
          <div class="col-12 col-md-4">
            <vivest-input
              formControlName="cpf"
              vivestFormat="cpf"
              placeholder=""
              label="CPF"
              name="cpf"
              type="text"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
          <div class="col-12 col-md-6">
            <div class="row g-4">
              <div class="col-4">
                <vivest-input
                  formControlName="dddCelular1"
                  vivestFormat="ddd"
                  label="DDD"
                  placeholder=""
                  name="dddCelular1"
                  type="tel"
                  autocomplete=""
                  [status]="status('dddCelular1')"
                  [errorMessage]="mensagemErro('dddCelular1')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
              <div class="col-8">
                <vivest-input
                  formControlName="celular1"
                  vivestFormat="celular"
                  label="Celular"
                  placeholder=""
                  name="celular1"
                  type="tel"
                  autocomplete=""
                  [status]="status('celular1')"
                  [errorMessage]="mensagemErro('celular1')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <vivest-input
              formControlName="dataNascimento"
              label="Data de Nascimento"
              placeholder=""
              name="dataNascimento"
              type="text"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
          <div class="col-12 col-md-6">
            <vivest-input
              formControlName="email"
              label="E-mail principal"
              name="email"
              type="email"
              autocomplete=""
              placeholder="Informe seu e-mail"
              [status]="status('email')"
              [errorMessage]="mensagemErro('email')"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
          <div class="col-12 col-md-6">
            <vivest-input
              formControlName="emailSecundario"
              label="E-mail secundário (Opcional)"
              name="emailSecundario"
              type="email"
              autocomplete="email"
              placeholder="Informe seu e-mail"
              [status]="status('emailSecundario')"
              [errorMessage]="mensagemErro('emailSecundario')"
              style="--vivest-input-inline-size: 100%"
            ></vivest-input>
          </div>
        </div>
        <div class="bloco">
          <div class="pergunta">
            <h4 class="mb-0">Você reside no exterior?</h4>
            <div class="opcoes">
              <vivest-radio
                label-variant="single-line"
                name="reside-exterior"
                value="sim"
                [checked]="mostraDadosExterior()"
                (change)="mostraDadosExterior.set(true)"
              >
                Sim
              </vivest-radio>
              <vivest-radio
                label-variant="single-line"
                name="reside-exterior"
                value="nao"
                [checked]="!mostraDadosExterior()"
                (change)="mostraDadosExterior.set(false)"
              >
                Não
              </vivest-radio>
            </div>
          </div>

            @if(mostraDadosExterior()) {
              <div class="row top-32">
                <div class="col-12 col-md-4">
                  <vivest-autocomplete
                    formControlName="pais"
                    [options]="paisOptions()"
                    icon="search" 
                    label="País" 
                    name="pais" 
                    placeholder="" 
                    [status]="status('pais')"
                    [errorMessage]="mensagemErro('pais')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-autocomplete>
                </div>
                <div class="col-12 col-md-4">
                  <vivest-input
                    formControlName="zipCode"
                    vivestFormat="digits"
                    label="ZIP Code"
                    [vivestMaxLength]="15"
                    placeholder=""
                    name="zipCode"
                    type="text"
                    autocomplete=""
                    [status]="status('zipCode')"
                    [errorMessage]="mensagemErro('zipCode')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-input>
                </div>
                <div class="col-12 col-md-4">
                  <vivest-input
                    formControlName="nif"
                    vivestFormat="digits"
                    label="NIF"
                    [vivestMaxLength]="30"
                    placeholder=""
                    name="nif"
                    type="text"
                    autocomplete=""
                    [status]="status('nif')"
                    [errorMessage]="mensagemErro('nif')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-input>
                </div>
              </div>
            }
        </div>
        <!-- Quem reside no exterior não informa o endereço no Brasil (campos sem obrigatoriedade). -->
        @if (!mostraDadosExterior()) {
          <div class="row" id="endereco">
            <div class="col-12 col-md-8">
              <div class="row g-4">
                <div class="col-12 col-sm-5">
                  <vivest-input
                    formControlName="cep"
                    vivestFormat="cep"
                    label="CEP"
                    placeholder=""
                    name="cep"
                    type="text"
                    icon="search"
                    autocomplete=""
                    (blur)="searchCep()"
                    [status]="status('cep')"
                    [errorMessage]="mensagemErro('cep')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-input>
                </div>
                <div class="col-4 col-sm-2">
                  <vivest-input
                    formControlName="uf"
                    label="UF"
                    placeholder=""
                    [vivestMaxLength]="2"
                    name="uf"
                    type="text"
                    autocomplete=""
                    [status]="status('uf')"
                    [errorMessage]="mensagemErro('uf')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-input>
                </div>
                <div class="col-8 col-sm-5">
                  <vivest-input
                    formControlName="cidade"
                    label="Cidade"
                    placeholder=""
                    [vivestMaxLength]="50"
                    name="cidade"
                    type="text"
                    autocomplete=""
                    [status]="status('cidade')"
                    [errorMessage]="mensagemErro('cidade')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <vivest-input
                formControlName="bairro"
                label="Bairro"
                [vivestMaxLength]="60"
                placeholder=""
                name="bairro"
                type="text"
                autocomplete=""
                [status]="status('bairro')"
                [errorMessage]="mensagemErro('bairro')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
            <div class="col-12 col-md-8">
              <vivest-input
                formControlName="logradouro"
                label="Endereço"
                placeholder=""
                name="logradouro"
                autocomplete=""
                placeholder=""
                [status]="status('logradouro')"
                [errorMessage]="mensagemErro('logradouro')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-input>
            </div>
            <div class="col-12 col-md-4">
              <div class="row g-4">
                <div class="col-4">
                  <vivest-input
                    formControlName="numero"
                    vivestFormat="digits"
                    label="Número"
                    [vivestMaxLength]="10"
                    placeholder=""
                    name="numero"
                    type="text"
                    autocomplete=""
                    [status]="status('numero')"
                    [errorMessage]="mensagemErro('numero')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-input>
                </div>
                <div class="col-8">
                  <vivest-input
                    formControlName="complemento"
                    label="Complemento (Opcional)"
                    placeholder=""
                    [vivestMaxLength]="50"
                    name="complemento"
                    type="text"
                    autocomplete=""
                    [status]="status('complemento')"
                    [errorMessage]="mensagemErro('complemento')"
                    style="--vivest-input-inline-size: 100%"
                  ></vivest-input>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="bordered-form">
        <div>
          <h4>Insira seus dados bancários</h4>
          <p>Indique onde devemos depositar a sua aposentadoria</p>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <vivest-autocomplete
                formControlName="banco"
                label="Banco"
                [options]="bancoOptions()"
                icon="search" 
                name="banco"
                placeholder="" 
                [status]="status('banco')"
                [errorMessage]="mensagemErro('banco')"
                style="--vivest-input-inline-size: 100%"
              ></vivest-autocomplete>
          </div>
          <div class="col-12 col-md-4">
            <div class="row g-4">
              <div class="col-8">
                <vivest-input
                  formControlName="agencia"
                  vivestFormat="digits"
                  label="Agência"
                  placeholder=""
                  name="agencia"
                  type="text"
                  [vivestMaxLength]="5"
                  autocomplete=""
                  [status]="status('agencia')"
                  [errorMessage]="mensagemErro('agencia')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
              <div class="col-4">
                <vivest-input
                  formControlName="digitoAgencia"
                  [vivestMaxLength]="1"
                  label="Dígito"
                  placeholder=""
                  name="digitoAgencia"
                  type="text"
                  autocomplete=""
                  [status]="status('digitoAgencia')"
                  [errorMessage]="mensagemErro('digitoAgencia')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="row g-4">
              <div class="col-8">
                <vivest-input
                  formControlName="conta"
                  vivestFormat="digits"
                  label="Conta"
                  placeholder=""
                  name="conta"
                  type="text"
                  [vivestMaxLength]="15"
                  autocomplete=""
                  [status]="status('conta')"
                  [errorMessage]="mensagemErro('conta')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
              <div class="col-4">
                <vivest-input
                  formControlName="digitoConta"
                  vivestFormat="digits"
                  [vivestMaxLength]="1"
                  label="Dígito"
                  placeholder=""
                  name="digitoConta"
                  type="text"
                  autocomplete=""
                  [status]="status('digitoConta')"
                  [errorMessage]="mensagemErro('digitoConta')"
                  style="--vivest-input-inline-size: 100%"
                ></vivest-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center buttons top-64">
        <vivest-button variant="outline" size="md" (click)="onReturn()">
          Voltar
        </vivest-button>
        <vivest-button variant="primary" size="md" (click)="onSubmit()">
          <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
          Continuar para Imposto de Renda
        </vivest-button>
      </div>
    </form>
  </div>
  
  <vivest-modal 
    heading="Importante!"
    [hasIcon]="false"
    [open]="openModal()"
    position="top"
    (vivest-close)="closeModal()"
  >
    <!-- O vivest-modal só exibe conteúdo nos slots icon, heading, description e actions. -->
    <div slot="description">
      <p class="mb-0 text-start">A atualização dos dados cadastrais é obrigatória para continuidade do processo. Certifique-se de que suas informações de contato,
      endereço e dados bancários estejam corretos e atualizados. Dados incorretos poderão causar atrasos no processamento da sua solicitação
      e no pagamento dos valores devidos.</p>
    </div>
    <vivest-button slot="actions" variant="outline" size="md" (click)="closeModal()">Fechar</vivest-button>
  </vivest-modal>
</div>